// extracted by mini-css-extract-plugin
export default {"root":"BundlePanel_root__1rGbB","divider":"BundlePanel_divider__igKiM","externalLink":"BundlePanel_externalLink__IkjwX"};